import React, { type ReactElement, type ReactNode } from 'react';
import classNames from 'classnames';
import Arrow from '~/public/assets/images/svg/arrow.svg';

export interface ListProps {
  children: ReactNode;
  className?: string;
}

interface ListItemProps extends ListProps {
  hiddenIcon?: boolean;
}

export default function List({ children, className }: ListProps): ReactElement {
  return (
    <div className={classNames('grid grid-cols-1', className)}>{children}</div>
  );
}

function ListItem({
  children,
  className,
  hiddenIcon,
}: ListItemProps): ReactElement {
  return (
    <div
      className={classNames(
        'flex h-[64px] items-center justify-between py-2',
        className
      )}
    >
      <div
        className={classNames('flex  items-center justify-start gap-2', [
          hiddenIcon ? 'w-full' : 'w-[90%]',
        ])}
      >
        {children}
      </div>
      {!hiddenIcon && (
        <div className="flex w-[10%] items-center justify-center">
          <Arrow className="h-[10px] w-[6px] rotate-180 text-secondary-300" />
        </div>
      )}
    </div>
  );
}

function ListItemIcon({ children, className }: ListProps): ReactElement {
  return (
    <div
      className={classNames(
        'flex h-[40px] w-[40px] items-center justify-center rounded-lg',
        className
      )}
    >
      {children}
    </div>
  );
}

function ListItemProperty({ children, className }: ListProps): ReactElement {
  return (
    <div
      className={classNames(
        'flex  items-center justify-start text-[14px] font-medium text-black-400',
        className
      )}
    >
      {children}
    </div>
  );
}

List.Item = ListItem;
List.Icon = ListItemIcon;
List.Property = ListItemProperty;
